// Бутоните в кутиите на таблото — по-ниски от тези в хедърите (кутиите са
// много и са една до друга). Основното действие на кутията е в меко кехлибарено,
// не в плътно: осем плътни бутона на един екран викат едновременно.
// `relative z-10` — над разпънатия бутон „отвори", който покрива цялата кутия.
const ACTION_BASE =
  "relative z-10 inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-lg px-3 py-1.5 text-[12.5px] leading-[normal] outline-none disabled:cursor-not-allowed disabled:opacity-55";

export const BOX_MAIN_ACTION_CLASS = `${ACTION_BASE} border border-brand-tint2 bg-brand-tint font-semibold text-brand-deep-ink hover:border-brand focus-visible:shadow-[0_0_0_2px_var(--color-brand)]`;

export const BOX_ACTION_CLASS = `${ACTION_BASE} border border-shade-3 bg-surface font-medium text-ink hover:border-shade-5 focus-visible:shadow-[0_0_0_3px_var(--color-brand-tint)]`;
